import { createJSONRequest } from '@/api/create-request'

export const generateDescription = (type, data) => createJSONRequest({
  method: 'POST',
  url: `/api/generative/description?type=${type}`,
  data: data,
})

export const generateText = (type, data, userGuidance) => createJSONRequest({
  method: 'POST',
  url: `/api/generative/text?type=${type}&userGuidance=${userGuidance}`,
  data: data,
})

export const generateContent = (type, data) => createJSONRequest({
  method: 'POST',
  url: `/api/generative/content?type=${type}`,
  data: data,
})
